import type { TFunction } from "Translations/Resources";
import { Resources } from "Translations/Resources";
import { z } from "zod";

const VALIDATION = Resources.Admin.SettlementPoolBoosts.Validation;

export const getStardustBoostFormSchema = (t: TFunction) =>
  z.object({
    boostAmount: z.number().int().min(0, t(VALIDATION.BoostAmountNonNegative)),
  });

export type StardustBoostFormData = z.infer<
  ReturnType<typeof getStardustBoostFormSchema>
>;

export const getValorBoostFormSchema = (t: TFunction) =>
  z.object({
    boostAmount: z.number().int().min(0, t(VALIDATION.BoostAmountNonNegative)),
    hunterPoolRatioPercent: z.number().int().min(0).max(100),
  });

export type ValorBoostFormData = z.infer<
  ReturnType<typeof getValorBoostFormSchema>
>;
